module.exports = __webpack_public_path__ + "img/planet.dc6ba9d4.jpg";